export function hasScope(scope) {
    return (window.Spark?.userScopes || []).includes(scope);
}
